import { render, staticRenderFns } from "./githubCustomerActionsRenderer.vue?vue&type=template&id=642c9ecb&scoped=true"
import script from "./githubCustomerActionsRenderer.vue?vue&type=script&lang=js"
export * from "./githubCustomerActionsRenderer.vue?vue&type=script&lang=js"
import style0 from "./githubCustomerActionsRenderer.vue?vue&type=style&index=0&id=642c9ecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c9ecb",
  null
  
)

export default component.exports